<template>
  <div class="flex justify-center col-span-2 gap-1">
    <!-- <button
      class="btn  btn-xs text-my-gray px-3"
      @click="store.addDialog(3, '', i)"
    >
      +{{ t(`game.role.3`) }}
    </button>
    <button
      class="btn  btn-xs text-my-gray px-3"
      @click="store.addDialog(1, '', i)"
    >
      +{{ t(`game.role.1`) }}
    </button>
    <button
      class="btn  btn-xs text-my-gray px-3"
      @click="store.addDialog(2, '', i)"
    >
      +{{ t(`game.role.2`) }}
    </button> -->
    <button
      class="btn btn-xs text-my-gray px-3"
      @click="store.addDialog(4, '', i)"
    >
      +{{ t(`game.role.4`) }}
    </button>
    <!-- <button
      class="btn  btn-xs text-my-gray px-3"
      @click="clickAiGenerate()"
    >
      +{{ t("Buttons.aiCompletion") }}
    </button> -->
  </div>
</template>

<script lang="ts" setup>
import { ApiPostGalGameDialogGenerate } from "@/apis/gal-game";
import { useStoryGameEditor } from "@/stores/storyGameEditor";
import { showLoadingToast } from "vant";
import { useI18n } from "vue-i18n";

const store = useStoryGameEditor();
const { t } = useI18n();
const props = defineProps({
  i: {
    type: Number,
  },
});
</script>
